import { render, staticRenderFns } from "./UserDetailOverlay.vue?vue&type=template&id=08b992b4&scoped=true"
import script from "./UserDetailOverlay.vue?vue&type=script&lang=js"
export * from "./UserDetailOverlay.vue?vue&type=script&lang=js"
import style0 from "./UserDetailOverlay.vue?vue&type=style&index=0&id=08b992b4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b992b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08b992b4')) {
      api.createRecord('08b992b4', component.options)
    } else {
      api.reload('08b992b4', component.options)
    }
    module.hot.accept("./UserDetailOverlay.vue?vue&type=template&id=08b992b4&scoped=true", function () {
      api.rerender('08b992b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserDetailOverlay.vue"
export default component.exports